import { render, staticRenderFns } from "./CmgToastModal.vue?vue&type=template&id=4c285a3e&scoped=true&lang=pug&"
import script from "./cmg-toast-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-toast-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgToastModal.vue?vue&type=style&index=0&id=4c285a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c285a3e",
  null
  
)

export default component.exports